module.exports = __webpack_public_path__ + "media/fonts/GintoNord-Medium-153dd2e469cd5378bdfc5e18b5c7bcaf.woff";